<template>
    <div class="server_pop">
        <div class="title">请选择区服</div>
        <van-search v-model="value" :clearable="false" show-action placeholder="请输入您的区服" @search="onSearch" class="search_area">
            <template #action>
                <div class="search_action" @click="onSearch">搜索</div>
            </template>
            <template #right-icon>
                <van-icon name="cross" v-if="value != ''" @click="value = ''"/>
            </template>
        </van-search>
        <notice-scroll :url="'game/app-server-list'" :params="{app_id,keyword: this.keywords}" :method="'get'" :text="''">
            <template slot-scope="scope">
                <div class="server_list">
                    <div :class="['server_item',{'active': home_server_id == item.server_id}]"
                        v-for="(item,i) in scope.data" :key="i" @click="chooseServer(item.server_id,item.server_name)">
                        {{ item.server_name }}
                    </div>
                </div>
            </template>
        </notice-scroll>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                value: '',
                keywords: ''
            }
        },
        computed: {
            app_id() {
                return this.$store.state.gameId
            },
            home_server_id() {
                return this.$store.state.home_server_id
            }
        },
        created() {},
        mounted() {

        },
        methods: {
            chooseServer(server_id, server_name) {
                this.$store.commit('bindHomeServer', {
                    server_id,
                    server_name
                })
                this.$parent.handleClose()
            },
            onSearch() {
                this.keywords = this.value
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .server_pop {
        height: calc(var(--vh, 1)*70);
        overflow-y: auto;

        .title {
            height: 5rem;
            line-height: 5.4rem;
            text-align: center;
            font-size: 1.8rem;
            font-weight: 700;
            text-align: center;
            background-color: #fff;
            position: sticky;
            top: 0;
        }

        .server_list {
            padding: 1.2rem 1.5rem;
            display: flex;
            flex-wrap: wrap;

            .server_item {
                width: 40%;
                margin: 0 5%;
                margin-bottom: 1.2rem;
                padding: 0.4rem 0.8rem;
                background-color: var(--themebgc);
                color: var(--theme);
                font-size: 1.2rem;
                border-radius: 10rem;
                text-align: center;
                word-break: break-all;
                cursor: pointer;
                &.active,
                &:hover {
                    background-color: var(--theme);
                    color: #fff;
                }
            }
        }
    }
    .search_area {
        position: sticky;
        top: 5rem;
        background-color: #fff;
        padding: .5rem 1rem .5rem 3rem;
        .van-search__content {
            background-color: #eee;
            border-radius: 10rem;
        }
        /deep/.van-field__right-icon {
            margin-right: 0.2rem;
            padding: 0;
            cursor: pointer;
            background-color: #999;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            line-height: 24px;
            color: #fff;
            font-size: 13px;
            text-align: center;
            transform: scale(0.6);
            transform-origin: 100% center;
        }
        .search_action {
            margin-left: 1rem;
            color: var(--theme);
            font-size: 1.2rem;
        }
    }
</style>